export const CDN_URL = 
    "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const LOGO_URL = 
   "https://content.jdmagicbox.com/comp/banaskantha/p8/9999p2748.2748.210921232217.w9p8/catalogue/food-bite-cafe-deesa-restaurants-ggzj564xj8.jpg?clr=";


export const MENU_API = 
    "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.4785095&lng=77.515362&restaurantId="


